import { Routes } from '@angular/router';
import { appPaths } from './app.paths';

export const defaultCode = 'MAT-US-2306137-v5.0';
export const newDefaultCode = 'MAT-US-2306137-v7.0';

export const routes: Routes = [
  {
    path: appPaths.HOME,
    loadComponent: () =>
      import('./pages/home/home.component').then((home) => home.HomeComponent),
    // Data object for SEO and sitemap
    data: {
      seo: {
        title: 'Screen for Type 1 Diabetes (T1D) | Screen It Like You Mean It',
        metaTags: [
          {
            name: 'description',
            content:
              "Discover why it's important to screen for Type 1 Diabetes (T1D) before serious complications can occur and the need for insulin.",
          },
          {
            property: 'og:title',
            content:
              'Screen for Type 1 Diabetes (T1D) | Screen It Like You Mean It',
          },
          {
            property: 'og:site_name',
            content: 'Screen for Type 1 Diabetes Patient Site',
          },
          {
            property: 'og:url',
            content: 'https://www.screenfortype1.com/',
          },
          {
            property: 'og:description',
            content:
              "Discover why it's important to screen for Type 1 Diabetes (T1D) before serious complications can occur and the need for insulin.",
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content: 'https://www.screenfortype1.com/assets/img/SFT1-logo.png',
          },
        ],
      },
      hreflang: [
        {
          rel: 'alternate',
          href: 'https://www.screenfortype1.com/',
          hreflang: 'x-default',
        },
        {
          rel: 'alternate',
          href: 'https://www.screenfortype1.com/',
          hreflang: 'en-us',
        },
        {
          rel: 'alternate',
          href: 'https://www.screenfortype1.com/es/',
          hreflang: 'es-us',
        },
      ],
      schema: [
        {
          '@context': 'http://schema.org',
          '@type': 'MedicalWebPage',
          audience: [
            {
              '@type': 'MedicalAudience',
              audiencetype: 'Patient',
              healthCondition: [
                {
                  '@type': 'MedicalCondition',
                  name: 'Type 1 Diabetes',
                },
              ],
            },
          ],
          keywords:
            'type 1 diabetes, t1d, screen for type 1, screen for type 1 diabetes, screen it like you mean it',
          url: 'https://www.screenfortype1.com/',
          description:
            "Discover why it's important to screen for Type 1 Diabetes (T1D) before serious complications can occur and the need for insulin.",
        },
      ],
      sitemap: {
        text: 'Home', //url text
        fragments: [], //fragments (if apply)
      },
      code: 'MAT-US-2306137-v12.0',
      date: '08/2026',
    },
  },
  {
    path: appPaths.WHATSYOURTD1RISK,
    loadComponent: () =>
      import('./pages/whats-your-td1-risk/whats-your-td1-risk.component').then(
        (c) => c.WhatsYourTd1RiskComponent,
      ),
    // Data object for SEO and sitemap
    data: {
      seo: {
        title: 'Risk Factors for Type 1 Diabetes (T1D) | Screen for Type 1',
        metaTags: [
          {
            name: 'description',
            content:
              'Learn more about the risk factors of Type 1 Diabetes (T1D) and take a quiz to see if you or a loved one could be at risk for T1D.',
          },
          {
            property: 'og:title',
            content:
              'Risk Factors for Type 1 Diabetes (T1D) | Screen for Type 1',
          },
          {
            property: 'og:site_name',
            content: 'Screen for Type 1 Diabetes Patient Site',
          },
          {
            property: 'og:url',
            content: 'https://www.screenfortype1.com/know-your-risk/',
          },
          {
            property: 'og:description',
            content:
              'Learn more about the risk factors of Type 1 Diabetes (T1D) and take a quiz to see if you or a loved one could be at risk for T1D.',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content: 'https://www.screenfortype1.com/assets/img/SFT1-logo.png',
          },
        ],
      },
      schema: [
        {
          '@context': 'http://schema.org',
          '@type': 'MedicalWebPage',
          audience: [
            {
              '@type': 'MedicalAudience',
              audiencetype: 'Patient',
              healthCondition: [
                {
                  '@type': 'MedicalCondition',
                  name: 'Type 1 Diabetes',
                },
              ],
            },
          ],
          keywords:
            'type 1 diabetes, t1d, screen for type 1, screen for type 1 diabetes, screen it like you mean it',
          url: 'https://www.screenfortype1.com/know-your-risk/',
          description:
            'Learn more about the risk factors of Type 1 Diabetes (T1D) and take a quiz to see if you or a loved one could be at risk for T1D.',
        },
      ],
      sitemap: {
        text: 'What’s your type 1 diabetes risk?', //url text
        fragments: [], //fragments (if apply)
      },
      code: 'MAT-US-2306139-v5.0',
      date: '06/2026',
    },
  },
  {
    path: appPaths.WHATIST1D,
    loadComponent: () =>
      import('./pages/what-is-t1d/what-is-t1d.component').then(
        (c) => c.WhatIsT1dComponent,
      ),
    // Data object for SEO and sitemap
    data: {
      seo: {
        title: 'Stages of Type 1 Diabetes (T1D) | Screen for Type 1',
        metaTags: [
          {
            name: 'description',
            content:
              'What is Type 1 Diabetes (T1D)? Learn more about the importance of beta cells and see the stages of T1D.',
          },
          {
            property: 'og:title',
            content: 'Stages of Type 1 Diabetes (T1D) | Screen for Type 1',
          },
          {
            property: 'og:site_name',
            content: 'Screen for Type 1 Diabetes Patient Site',
          },
          {
            property: 'og:url',
            content:
              'https://www.screenfortype1.com/stages-of-type-1-diabetes/',
          },
          {
            property: 'og:description',
            content:
              'What is Type 1 Diabetes (T1D)? Learn more about the importance of beta cells and see the stages of T1D.',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content: 'https://www.screenfortype1.com/assets/img/SFT1-logo.png',
          },
        ],
      },
      schema: [
        {
          '@context': 'http://schema.org',
          '@type': 'MedicalWebPage',
          audience: [
            {
              '@type': 'MedicalAudience',
              audiencetype: 'Patient',
              healthCondition: [
                {
                  '@type': 'MedicalCondition',
                  name: 'Type 1 Diabetes',
                },
              ],
            },
          ],
          keywords:
            'type 1 diabetes, t1d, screen for type 1, screen for type 1 diabetes, screen it like you mean it',
          url: 'https://www.screenfortype1.com/stages-of-type-1-diabetes/',
          description:
            'What is Type 1 Diabetes (T1D)? Learn more about the importance of beta cells and see the stages of T1D.',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          description:
            "What really causes type 1 diabetes (T1D)? Follow the journey of beta cells, tiny insulin-producing cells in the pancreas, and see what happens when the immune system mistakenly attacks them. Whether you're a parent, patient, or simply curious, this video explains how T1D develops, why beta cells matter, and how autoantibody screening can help spot T1D before symptoms start. Visit screenfortype1.com to learn how screening early for T1D-related autoantibodies could help give you time to discuss next steps with your doctor.",
          name: 'The Silent Attack: What Really Causes Type 1 Diabetes',
          thumbnailUrl: 'https://i.ytimg.com/vi/ZAEy13NqMzE/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=ZAEy13NqMzE',
          uploadDate: '2025-07-16',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          description:
            'Adam Schefter delivers an urgent news update on the latest developments inside the pancreas, as reports come in that an early attack on beta cells is underway. Talk to your doctor about making a type 1 diabetes screening plan today.',
          name: 'Inside the Betaverse with Adam Schefter – The Early Stages of T1D',
          thumbnailUrl: 'https://i.ytimg.com/vi/YIdIPa8P_Xs/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=YIdIPa8P_Xs',
          uploadDate: '2026-02-19',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          description:
            'Adam Schefter reports on a case of mistaken identity inside the pancreas as immune system t-cells attack the beta cells they usually protect. Talk to your doctor about making a T1D screening plan today.',
          name: 'Inside the Betaverse with Adam Schefter – Attack on Beta',
          thumbnailUrl: 'https://i.ytimg.com/vi/KoH1j7CV-M4/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=KoH1j7CV-M4',
          uploadDate: '2026-02-19',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          description:
            'Adam Schefter explains the significance of C-Peptide and why researchers are using C-Peptide levels as a biomarker of beta cell function. Talk to your doctor about making a T1D screening plan today.',
          name: 'Inside the Betaverse with Adam Schefter – What is C-Peptide?',
          thumbnailUrl: 'https://i.ytimg.com/vi/fdpuWI-ZwqY/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=fdpuWI-ZwqY',
          uploadDate: '2026-02-19',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          description:
            'Adam Schefter reports on surprising developments inside the pancreas, where it appears that - despite a type 1 diabetes (T1D) diagnosis – not all beta cells have called it quits. Talk to your doctor about making a T1D screening plan today.',
          name: 'Inside the Betaverse with Adam Schefter – The Honeymoon Phase',
          thumbnailUrl: 'https://i.ytimg.com/vi/e37_2TfYQk0/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=e37_2TfYQk0',
          uploadDate: '2026-02-19',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          description:
            'Adam Schefter follows beta cells into the replay booth to assess the impact of blood sugar spikes and the significance of metabolic memory. Talk to your doctor about making a T1D screening plan today.',
          name: 'Inside the Betaverse with Adam Schefter – Metabolic Memory',
          thumbnailUrl: 'https://i.ytimg.com/vi/QG3QB7Z61cs/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=QG3QB7Z61cs',
          uploadDate: '2026-02-19',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          description:
            'Adam Schefter goes inside the pancreas for an exclusive interview with a beta cell, breaking down what really happens during the stages of type 1 diabetes. Talk to your doctor about screening and about making a T1D screening plan today.',
          name: 'Inside the Betaverse with Adam Schefter –The Last Beta Cell',
          thumbnailUrl: 'https://i.ytimg.com/vi/9Cm3H_ByNTI/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=9Cm3H_ByNTI',
          uploadDate: '2026-02-19',
        },
      ],
      sitemap: {
        text: 'What is early-stage type 1 diabetes?', //url text
        fragments: [], //fragments (if apply)
      },
      code: 'MAT-US-2306142-v8.0',
      date: '08/2026',
      year: '2026',
    },
  },
  {
    path: appPaths.COSTSNOTKNOWKING,
    loadComponent: () =>
      import('./pages/costs-not-knowing/costs-not-knowing.component').then(
        (c) => c.CostsNotKnowingComponent,
      ),
    // Data object for SEO and sitemap
    data: {
      seo: {
        title: 'Why Screen for Type 1 Diabetes (T1D) | Screen for Type 1',
        metaTags: [
          {
            name: 'description',
            content:
              "Discover from real Type 1 Diabetes (T1D) patients and caregivers why it's important to screen for T1D early and why a majority of patients regret not taking an autoantibody test.",
          },
          {
            property: 'og:title',
            content: 'Why Screen for Type 1 Diabetes (T1D) | Screen for Type 1',
          },
          {
            property: 'og:site_name',
            content: 'Screen for Type 1 Diabetes Patient Site',
          },
          {
            property: 'og:url',
            content: 'https://www.screenfortype1.com/why-screen-for-t1d/',
          },
          {
            property: 'og:description',
            content:
              "Discover from real Type 1 Diabetes (T1D) patients and caregivers why it's important to screen for T1D early and why a majority of patients regret not taking an autoantibody test.",
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content: 'https://www.screenfortype1.com/assets/img/SFT1-logo.png',
          },
        ],
      },
      schema: [
        {
          '@context': 'http://schema.org',
          '@type': 'MedicalWebPage',
          audience: [
            {
              '@type': 'MedicalAudience',
              audiencetype: 'Patient',
              healthCondition: [
                {
                  '@type': 'MedicalCondition',
                  name: 'Type 1 Diabetes',
                },
              ],
            },
          ],
          keywords:
            'type 1 diabetes, t1d, screen for type 1, screen for type 1 diabetes, screen it like you mean it',
          url: 'https://www.screenfortype1.com/why-screen-for-t1d/',
          description:
            "Discover from real Type 1 Diabetes (T1D) patients and caregivers why it's important to screen for T1D early and why a majority of patients regret not taking an autoantibody test.",
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          description:
            'Not knowing about type 1 diabetes in advance can have costs, both for adults living with the disease themselves and also for caregivers of children with type 1 diabetes. Far too many people are diagnosed with type 1 diabetes when they are already in a late stage of the disease. Serious complications can occur in stage 3, which was the case for Cassie Bailey’s son, Josiah, who was diagnosed at five years old when he was in diabetic ketoacidosis (DKA). After Josiah collapsed at the bottom of the stairs and was taken to the hospital, the doctor said he may not have woken up in the morning had he not been brought in when he was. It was a harrowing and life-changing experience for the family. Today, Cassie is dedicated to sharing how early screening for type 1 diabetes and follow-up monitoring may help others prepare for the realities of this disease. Because, while type 1 diabetes cannot be prevented, it can be detected early through autoantibody screenings. This #AmericanDiabetesMonth, stories like Cassie’s emphasize why #KnowledgeIsPower and how knowing sooner may allow you to take charge of your family’s health. Watch Cassie’s story, visit ScreenForType1.com, and talk to your doctor about screening early for type 1 diabetes.',
          name: "The Bailey Family's T1D Diagnosis Story",
          thumbnailUrl: 'https://i.ytimg.com/vi/nUa_5NxEqTY/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=nUa_5NxEqTY',
          uploadDate: '2024-10-21',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          description:
            'When Devin Cordle was pregnant with her first child, she was diagnosed with gestational diabetes—but postpartum, she continued to not feel like herself. As she focused all her time and attention on her new baby’s health and livelihood, her own wellbeing took a backseat. This went on for months—during which time Devin felt exhausted, confused, and overwhelmed by both her role as a new mother, and her uncertainty about her own health. As she progressively got sicker, her husband pushed her to seek help, so Devin finally spoke with her doctor about the wide range of symptoms she had been experiencing. Devin was ultimately diagnosed with type 1 diabetes, a moment when she recalls feeling great relief—to finally be in a position where she had some answers. Devin has since welcomed her second child and feels more empowered in health journey than ever before. As one of six siblings, she also feels strongly about encouraging her family members to get screened early for type 1 diabetes because familial history is the highest risk factor for developing this chronic autoimmune disease. However, 90% of people with type 1 diabetes have no family history at all. In honor of #AmericanDiabetesMonth, hear more from Devin about her journey, visit ScreenForType1.com, and talk to your doctor about screening early for type 1 diabetes.',
          name: 'Devin Cordle’s T1D Diagnosis Story',
          thumbnailUrl: 'https://i.ytimg.com/vi/kdFPKjqXLlc/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=kdFPKjqXLlc',
          uploadDate: '2024-11-04',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          description:
            'When Cara Van Brocklin’s oldest son Hanes began losing weight, feeling tired, and making frequent trips to the bathroom, she initially thought he was just experiencing “growing pains.” It wasn’t until his health rapidly declined that Cara and her husband Brody knew something was terribly wrong. Once in the hospital, Hanes—nearly in diabetic ketoacidosis (DKA)—was diagnosed with type 1 diabetes (T1D), leaving Cara and Brody (who have no known family history of the disease) stunned and overwhelmed. But their T1D journey wasn’t over; three years later, their second son Arrow began exhibiting the same symptoms. Thankfully, the Van Brocklins were now familiar with the warning signs for T1D and knew to act quickly to get Arrow the help he needed. While caring for two children with T1D has not been easy, Cara and Brody are using their experience to educate other families about the importance of information and early T1D risk detection. Had Hanes and Arrow been screened for T1D, Cara and Brody may have had the opportunity to make more informed choices around their children’s health and better prepare for the road ahead. For this reason, the couple plans to screen their other two children, who are up to 15x more likely to develop the disease given their brothers’ diagnoses. To hear more from Cara and Brody about their family’s journey, visit ScreenForType1.com and talk to your doctor about screening early for type 1 diabetes.',
          name: 'The Van Brocklin Family’s T1D Diagnosis Story',
          thumbnailUrl: 'https://i.ytimg.com/vi/jgZ-Ur5uf1w/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=jgZ-Ur5uf1w',
          uploadDate: '2025-01-24',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          description:
            'Imagine having type 1 diabetes and still performing at the top of your game? It’s not easy, but for Adam Shefter, preparation is vital - for your game and for your health. Watch Adam’s story and visit The1Pledge.com to learn more so you can be prepared for whatever may come.',
          name: "Type 1 Diabetes Screening, This is Adam's 1 Pledge",
          thumbnailUrl: 'https://i.ytimg.com/vi/w0f2mxIiV64/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=w0f2mxIiV64',
          uploadDate: '2024-05-28',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          description:
            'When it comes to type 1 diabetes, Adam Schefter and his wife, Sharri, are staying ahead of the game. They’re sharing their story about type 1 diabetes, and why screening their kids is so important. Because if just 1 person in your family has type 1 diabetes, you’re up to 15x more likely to get it too. Watch Adam and Sharri’s story, and take The 1 Pledge to screen early for type 1 diabetes.',
          name: 'The 1 Pledge: Adam and Sharri’s Story',
          thumbnailUrl: 'https://i.ytimg.com/vi/8_5QGzsAFdg/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=8_5QGzsAFdg',
          uploadDate: '2023-10-19',
        },
      ],
      sitemap: {
        text: 'The costs of not knowing', //url text
        fragments: [], //fragments (if apply)
      },
      code: 'MAT-US-2306144-v9.0',
      date: '08/2026',
    },
  },
  {
    path: appPaths.BENEFITSOFKNOWING,
    loadComponent: () =>
      import('./pages/the-benefits-of-knowing/the-benefits-of-knowing.component').then(
        (c) => c.TheBenefitsOfKnowingComponent,
      ),
    // Data object for SEO and sitemap
    data: {
      seo: {
        title:
          'Talk to Your Doctor About Type 1 Diabetes (T1D) | Screen for Type 1',
        metaTags: [
          {
            name: 'description',
            content:
              'Learn how to talk to your doctor about Type 1 Diabetes (T1D), see the signs and symptoms, how to monitor your blood sugar, and find the right care team.',
          },
          {
            property: 'og:title',
            content:
              'Talk to Your Doctor About Type 1 Diabetes (T1D) | Screen for Type 1',
          },
          {
            property: 'og:site_name',
            content: 'Screen for Type 1 Diabetes Patient Site',
          },
          {
            property: 'og:url',
            content: 'https://www.screenfortype1.com/benefits-of-knowing/',
          },
          {
            property: 'og:description',
            content:
              'Learn how to talk to your doctor about Type 1 Diabetes (T1D), see the signs and symptoms, how to monitor your blood sugar, and find the right care team.',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content: 'https://www.screenfortype1.com/assets/img/SFT1-logo.png',
          },
        ],
      },
      schema: [
        {
          '@context': 'http://schema.org',
          '@type': 'MedicalWebPage',
          audience: [
            {
              '@type': 'MedicalAudience',
              audiencetype: 'Patient',
              healthCondition: [
                {
                  '@type': 'MedicalCondition',
                  name: 'Type 1 Diabetes',
                },
              ],
            },
          ],
          keywords:
            'type 1 diabetes, t1d, screen for type 1, screen for type 1 diabetes, screen it like you mean it',
          url: 'https://www.screenfortype1.com/benefits-of-knowing/',
          description:
            'Learn how to talk to your doctor about Type 1 Diabetes (T1D), see the signs and symptoms, how to monitor your blood sugar, and find the right care team.',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          name: "Amanda's T1D Screening Story",
          thumbnailUrl: 'https://i.ytimg.com/vi/mVYWGmFLcoY/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=mVYWGmFLcoY',
          uploadDate: '2025-02-28',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          name: "The Hoffman Family's T1D Diagnosis Journey",
          thumbnailUrl: 'https://i.ytimg.com/vi/JIoHCnBRX0U/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=JIoHCnBRX0U',
          uploadDate: '2025-08-21',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          name: "The Zortman Family's T1D Diagnosis Journey",
          thumbnailUrl: 'https://i.ytimg.com/vi/6acIYCHhwHY/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=6acIYCHhwHY',
          uploadDate: '2026-05-27',
        },
      ],
      sitemap: {
        text: 'The benefits of knowing', //url text
        fragments: [], //fragments (if apply)
      },
      code: 'MAT-US-2306146-v9.0',
      date: '06/2026',
      year: '2026',
    },
  },
  {
    path: appPaths.FAMILYHISTORY,
    loadComponent: () =>
      import('./pages/family-history-survey/family-history-survey.component').then(
        (c) => c.FamilyHistorySurveyComponent,
      ),
    data: {
      seo: {
        title:
          'The Family Factor Type 1 Diabetes (T1D) Risk Awareness Survey | Screen for Type 1',
        metaTags: [
          {
            name: 'description',
            content:
              'Is your family at risk for Type 1 Diabetes (T1D)? See The Family Factor T1D risk awareness survey findings that show a lack of disease awareness among those with family history of T1D.',
          },
          {
            property: 'og:title',
            content:
              'The Family Factor Type 1 Diabetes (T1D) Risk Awareness Survey | Screen for Type 1',
          },
          {
            property: 'og:site_name',
            content: 'Screen for Type 1 Diabetes Patient Site',
          },
          {
            property: 'og:url',
            content:
              'https://www.screenfortype1.com/the-family-factor-t1d-survey/',
          },
          {
            property: 'og:description',
            content:
              'Is your family at risk for Type 1 Diabetes (T1D)? See The Family Factor T1D risk awareness survey findings that show a lack of disease awareness among those with family history of T1D.',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content: 'https://www.screenfortype1.com/assets/img/SFT1-logo.png',
          },
        ],
      },
      schema: [
        {
          '@context': 'http://schema.org',
          '@type': 'MedicalWebPage',
          audience: [
            {
              '@type': 'MedicalAudience',
              audiencetype: 'Patient',
              healthCondition: [
                {
                  '@type': 'MedicalCondition',
                  name: 'Type 1 Diabetes',
                },
              ],
            },
          ],
          keywords:
            'type 1 diabetes, t1d, screen for type 1, screen for type 1 diabetes, screen it like you mean it',
          url: 'https://www.screenfortype1.com/the-family-factor-t1d-survey/',
          description:
            'Is your family at risk for Type 1 Diabetes (T1D)? See The Family Factor T1D risk awareness survey findings that show a lack of disease awareness among those with family history of T1D.',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          name: "The Berce Family's T1D Diagnosis Journey",
          thumbnailUrl: 'https://i.ytimg.com/vi/u3BnR-t0Yj8/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=u3BnR-t0Yj8',
          uploadDate: '2026-07-14',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          name: 'T1D Conversations – Keiva & Ashley',
          thumbnailUrl: 'https://i.ytimg.com/vi/piNKXUSebM/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=piNKXUSebM',
          uploadDate: '2026-08-31',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          name: 'T1D Conversations – Keiva & Jenny',
          thumbnailUrl: 'https://i.ytimg.com/vi/_iTuFG09fL4/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=_iTuFG09fL4',
          uploadDate: '2026-08-31',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          name: 'T1D Conversations – Keiva & Lindsey',
          thumbnailUrl: 'https://i.ytimg.com/vi/HjXgGOcdYEc/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=HjXgGOcdYEc',
          uploadDate: '2026-08-31',
        },
      ],
      sitemap: {
        text: 'The family history survey',
        fragments: [],
      },
      code: 'MAT-US-2606422-v2.0',
      date: '08/2026',
    },
  },
  {
    path: 'take-the-pledge',
    redirectTo: appPaths.COSTSNOTKNOWKING,
  },
  {
    path: 'make-a-pledge',
    redirectTo: appPaths.COSTSNOTKNOWKING,
  },
  {
    path: appPaths.HOWTOSCREEN,
    loadComponent: () =>
      import('./pages/how-to-screen/how-to-screen.component').then(
        (c) => c.HowToScreenComponent,
      ),
    // Data object for SEO and sitemap
    data: {
      seo: {
        title: 'About Type 1 Diabetes (T1D) Screening | Screen for Type 1',
        metaTags: [
          {
            name: 'description',
            content:
              'Learn about Type 1 Diabetes (T1D) screening, how to get screened, what your test results mean, and find T1D specialists near you.',
          },
          {
            property: 'og:title',
            content:
              'About Type 1 Diabetes (T1D) Screening | Screen for Type 1',
          },
          {
            property: 'og:site_name',
            content: 'Screen for Type 1 Diabetes Patient Site',
          },
          {
            property: 'og:url',
            content: 'https://www.screenfortype1.com/about-t1d-screening/',
          },
          {
            property: 'og:description',
            content:
              'Learn about Type 1 Diabetes (T1D) screening, how to get screened, what your test results mean, and find T1D specialists near you.',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content: 'https://www.screenfortype1.com/assets/img/SFT1-logo.png',
          },
        ],
      },
      schema: [
        {
          '@context': 'http://schema.org',
          '@type': 'MedicalWebPage',
          audience: [
            {
              '@type': 'MedicalAudience',
              audiencetype: 'Patient',
              healthCondition: [
                {
                  '@type': 'MedicalCondition',
                  name: 'Type 1 Diabetes',
                },
              ],
            },
          ],
          keywords:
            'type 1 diabetes, t1d, screen for type 1, screen for type 1 diabetes, screen it like you mean it',
          url: 'https://www.screenfortype1.com/about-t1d-screening/',
          description:
            'Learn about Type 1 Diabetes (T1D) screening, how to get screened, what your test results mean, and find T1D specialists near you.',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          name: 'Doctor Patient Discussion (Adam Schefter)',
          thumbnailUrl: 'https://i.ytimg.com/vi/n-jdOfgDIT4/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=n-jdOfgDIT4',
          uploadDate: '2025-04-21',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          description:
            'After watching his wife’s experience with type 1 diabetes (T1D), Adam Schefter knows just how important early T1D screening can be when it comes to preparing for the future. So he’s showing everyone how to screen at home! Watch as Adam talks through the at-home screening process. It’s a great tool for individuals and families looking to make informed decisions with their healthcare provider (HCP) about their health. Talk to your doctor about making a T1D screening plan today.',
          name: 'Doctor Patient Discussion (Adam Schefter)',
          thumbnailUrl: 'https://i.ytimg.com/vi/QC_XlUj_bAc/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=QC_XlUj_bAc',
          uploadDate: '2026-01-06',
        },
      ],
      sitemap: {
        text: 'How to screen', //url text
        fragments: [], //fragments (if apply)
      },
      code: 'MAT-US-2409684-v5.0',
      date: '06/2026',
    },
  },
  {
    path: appPaths.USEFULTOOLS,
    loadComponent: () =>
      import('./pages/useful-tools/useful-tools.component').then(
        (c) => c.UsefulToolsComponent,
      ),
    // Data object for SEO and sitemap
    data: {
      seo: {
        title: 'Type 1 Diabetes (T1D) Resources | Screen for Type 1',
        metaTags: [
          {
            name: 'description',
            content:
              'Discover helpful Type 1 Diabetes (T1D) resources including T1D organizations and frequently asked questions.',
          },
          {
            property: 'og:title',
            content: 'Type 1 Diabetes (T1D) Resources | Screen for Type 1',
          },
          {
            property: 'og:site_name',
            content: 'Screen for Type 1 Diabetes Patient Site',
          },
          {
            property: 'og:url',
            content: 'https://www.screenfortype1.com/action-plan/',
          },
          {
            property: 'og:description',
            content:
              'Discover helpful Type 1 Diabetes (T1D) resources including T1D organizations and frequently asked questions.',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content: 'https://www.screenfortype1.com/assets/img/SFT1-logo.png',
          },
        ],
      },
      schema: [
        {
          '@context': 'http://schema.org',
          '@type': 'MedicalWebPage',
          audience: [
            {
              '@type': 'MedicalAudience',
              audiencetype: 'Patient',
              healthCondition: [
                {
                  '@type': 'MedicalCondition',
                  name: 'Type 1 Diabetes',
                },
              ],
            },
          ],
          keywords:
            'type 1 diabetes, t1d, screen for type 1, screen for type 1 diabetes, screen it like you mean it',
          url: 'https://www.screenfortype1.com/action-plan/',
          description:
            'Discover helpful Type 1 Diabetes (T1D) resources including T1D organizations and frequently asked questions.',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          name: 'Doctor Patient Discussion (Adam Schefter)',
          thumbnailUrl: 'https://i.ytimg.com/vi/n-jdOfgDIT4/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=n-jdOfgDIT4',
          uploadDate: '2025-04-21',
        },
        {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: [
            {
              '@type': 'Question',
              name: 'What is early-stage type 1 diabetes?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'This is when type 1 diabetes has begun, but the body can still make enough insulin to keep blood sugar in a relatively health range. Early-stage autoimmune type 1 diabetes is not the same as the honeymoon stage. The honeymoon stage is a short period after diagnosis of insulin-dependent type 1 diabetes when diabetes symptoms seem to get better.',
              },
            },
            {
              '@type': 'Question',
              name: 'Is there a difference between &quot;autoimmune type 1 diabetes&quot; and &quot;type 1 diabetes&quot;?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'No. These terms are used interchangeably. Type 1 diabetes is an autoimmune condition that happens when the body produces autoantibodies that signal the body to mistakenly attack healthy cells that make insulin. These autoantibodies are what can be detected through screening.',
              },
            },
            {
              '@type': 'Question',
              name: 'How does the autoantibody test work? How accurate is the test?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'An autoantibody test is a blood test that can spot type 1 diabetes early—before the risk of life-threating complications or the need for insulin. It does this by looking for diabetes-related autoantibodies. These are proteins that appear in the blood when autoimmune type 1 diabetes begins, even in early stages before there are any symptoms. Two or more autoantibodies are a strong sign that the earliest stages of type 1 diabetes may have begun. The test is usually performed by using a finger prick or blood draw.\n\nAutoantibody screening is generally considered to be highly accurate, and is widely accepted by medical professionals as a measure to reliably predict if a person has or will eventually develop type 1 diabetes. In fact, once screening detects two or more autoantibodies, your lifetime risk of developing insulin dependent type 1 diabetes increases to almost 100%.\n\nAutoantibody screening can also help determine whether or not you have type 1 or type 2 diabetes, as autoantibodies are generally not present in screening results for those diagnosed with type 2 diabetes.',
              },
            },
            {
              '@type': 'Question',
              name: 'Is the autoantibody test usually included as part of my standard annual physical exam?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Autoantibody testing is not typically included as part of routine testing during a standard annual physical. Be proactive and start the conversation about screening options with your doctor at your next check-up to determine what makes the most sense for you.',
              },
            },
            {
              '@type': 'Question',
              name: 'How much does the autoantibody test cost? Is it covered by insurance?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Each screening option has a different cost. For example, Enable Biosciences offers an at-home test you can get from a doctor. TrialNet offers free screening to those who have a relative with type 1 diabetes. The cost of screening at a lab varies depending on your insurance coverage—but is potentially low cost or even $0 out-of-pocket. Talk to your doctor and insurance provider to find out screening coverage.',
              },
            },
            {
              '@type': 'Question',
              name: "What's the difference between a genetic test, a glucose test, an A1C and an autoantibody test?",
              acceptedAnswer: {
                '@type': 'Answer',
                text: "The various types of screening and tests around type 1 diabetes can be confusing. Let's lay it out: An autoantibody test is a blood test that can spot type 1 diabetes early—before noticeable symptoms. It does this by looking for diabetes-related autoantibodies. Based on the results, you may be able to tell if you or your loved one is in the earliest stages of type 1 diabetes.\n\nGenetic testing can identify a higher risk of developing type 1 diabetes over someone’s life by looking at their DNA (the building blocks of cells). It can’t give information about whether stages of type 1 diabetes have begun.\n\nFinally, a blood glucose test measures the level of glucose, or sugar, currently in your blood, while an A1C takes the average level of glucose in your blood over the past ~2 months. The A1C test helps providers assess how an overall management plan is working, while a glucose test just provides a moment in time snapshot.",
              },
            },
            {
              '@type': 'Question',
              name: 'At what age can I start to get my family screened?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Most T1D screening tests are available for children aged 2 years and older but infants as young as 6 months are able to be screened. Talk to your doctor about when is the best age to screen and whether your child might be at elevated risk.',
              },
            },
            {
              '@type': 'Question',
              name: 'What are the potential benefits of getting screened?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Many. Whether a person screens or not, if they have autoimmune type 1 diabetes, it will progress and get worse as time goes on. Eventually, life-threatening complications can happen, often seemingly out of nowhere. Screening can identify the risk of autoimmune type 1 diabetes before symptoms appear.\n\nIf a screening test shows that you or a loved one is in the early stages of type 1 diabetes, there’s more that you can do.\nKnowing your results can help you:\n\nTalk to your doctor about options and keep up with advancements in treatment\nLearn the symptoms of type 1 before they appear and lower the risks of possible life-threatening complications\nFind the right care team and type 1 diabetes community to support you\nTalk to your doctor about screening and what comes next.',
              },
            },
            {
              '@type': 'Question',
              name: 'What are autoantibodies?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Autoantibodies are proteins that appear in the blood when type 1 diabetes begins, even in early stages before there are any symptoms.\n\nWhen 2 or more autoantibodies are present, it means the early stages of type 1 diabetes may have begun.',
              },
            },
            {
              '@type': 'Question',
              name: 'What should I do after getting my screening results?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'The next steps depend on the results of screening. There are 3 possible results:\n\n0 Autoantibodies: If the test finds no autoantibodies, talk to your doctor about an appropriate rescreening schedule, especially if there’s a family history of T1D. Just because screening didn’t detect T1D-related autoantibodies now doesn’t mean they won’t appear in the future.\n1 Autoantibody: If the test finds 1 autoantibody, you or your loved one is at a higher risk for developing type 1 diabetes. You can talk to your doctor about rescreening first to confirm that there are no additional autoantibodies, and rescreening schedule to see if more autoantibodies develop.\n2+ Autoantibodies: If the test finds 2 or more autoantibodies, this is a strong sign that the earliest stages of type 1 diabetes may have begun. Talk to your doctor about monitoring blood sugars and other next steps, so you can take charge of your health.',
              },
            },
            {
              '@type': 'Question',
              name: 'How do I know if I/my loved one should get screened?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Anyone, at any age, can develop autoimmune type 1 diabetes—no matter their diet or exercise choices.\n\nIf just 1 person in your family has type 1 diabetes, you’re up to 15x more likely to develop it too. That’s why it’s important to screen it like you mean it, so you can learn the results and take action.\n\nTo learn more about your or your loved one’s risk, talk to your doctor and take The Type 1 Risk Quiz.\n\nAnyone can be screened for diabetes-related autoantibodies, but it’s especially important if others in your family have type 1 diabetes. Talk to your doctor about the best screening option for you or your loved one.',
              },
            },
            {
              '@type': 'Question',
              name: "My/my loved one's doctor hasn't recommended early screening. Should I bring it up at my next appointment?",
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Your doctor’s guidance and expertise should always be taken seriously. If you feel like you or a loved one could benefit from early screening, continue having the conversation with your doctor. You can also consider getting a second opinion from a different healthcare professional, like an endocrinologist.',
              },
            },
            {
              '@type': 'Question',
              name: 'What is my state doing to share T1D resources?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Following patient advocacy, many states have passed legislation or directed health departments to share resources and information for families about T1D screening. You can learn more about these efforts and how you can get involved to help enact screening education laws in your state at https://www.gettingaheadoftype1.org/regulatory-center',
              },
            },
            {
              '@type': 'Question',
              name: 'Where can I find more support or resources?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'The type 1 diabetes community is a powerful network. If you want to learn more about early screening, find stories about living with type 1 diabetes, or connect with the community, check out some helpful programs below or read about different organizations:\n\nType1Talk: Sign up to get more information and educational resources about the importance of early screening\nBreakthrough T1D’s T1Detect Program: Sign up for this education and awareness program to explore additional screening options, available research studies, and steps to take after getting test results\nAsk the Experts: Call or email an expert to get more information, support, and advice about autoimmune type 1 diabetes and screening\nJoin the Screen for Type 1 community on social media through Instagram, Facebook, and YouTube.\n\nGet updates and more information about screening and management treatment.',
              },
            },
          ],
        },
      ],
      sitemap: {
        text: 'Make a plan and FAQs', //url text
        fragments: [], //fragments (if apply)
      },
      code: 'MAT-US-2306147-v7.0',
      date: '06/2026',
      year: '2026',
    },
  },
  {
    path: appPaths.SIGNUP,
    loadComponent: () =>
      import('./pages/sign-up/sign-up.component').then(
        (c) => c.SignUpComponent,
      ),
    // Data object for SEO and sitemap
    data: {
      seo: {
        title: 'Sign Up for Updates | Screen for Type 1',
        metaTags: [
          {
            name: 'description',
            content:
              'Sign up to receive the latest updates, valuable tools, and resources for Type 1 Diabetes (T1D) from Screen for Type 1.',
          },
          {
            property: 'og:title',
            content: 'Sign Up for Updates | Screen for Type 1',
          },
          {
            property: 'og:site_name',
            content: 'Screen for Type 1 Diabetes Patient Site',
          },
          {
            property: 'og:url',
            content: 'https://www.screenfortype1.com/get-updates/',
          },
          {
            property: 'og:description',
            content:
              'Sign up to receive the latest updates, valuable tools, and resources for Type 1 Diabetes (T1D) from Screen for Type 1.',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content: 'https://www.screenfortype1.com/assets/img/SFT1-logo.png',
          },
        ],
      },
      schema: [
        {
          '@context': 'http://schema.org',
          '@type': 'MedicalWebPage',
          audience: [
            {
              '@type': 'MedicalAudience',
              audiencetype: 'Patient',
              healthCondition: [
                {
                  '@type': 'MedicalCondition',
                  name: 'Type 1 Diabetes',
                },
              ],
            },
          ],
          keywords:
            'type 1 diabetes, t1d, screen for type 1, screen for type 1 diabetes, screen it like you mean it',
          url: 'https://www.screenfortype1.com/get-updates/',
          description:
            'Sign up to receive the latest updates, valuable tools, and resources for Type 1 Diabetes (T1D) from Screen for Type 1.',
        },
      ],
      sitemap: {
        text: 'Sign up for updates', //url text
        fragments: [], //fragments (if apply)
      },
      code: 'MAT-US-2404268-v3.0',
      date: '07/2025',
    },
  },
  {
    path: appPaths.THANKYOU,
    loadComponent: () =>
      import('./pages/thank-you/thank-you.component').then(
        (c) => c.ThankYouComponent,
      ),
    // Data object for SEO and sitemap
    data: {
      seo: {
        title: 'Thank You for Signing Up | Screen for Type 1',
        metaTags: [
          {
            name: 'description',
            content:
              'Thank you for signing up for updates from Screen for Type 1.',
          },
          {
            name: 'robots',
            content: 'noindex',
          },
          {
            property: 'og:title',
            content: 'Thank You for Signing Up | Screen for Type 1',
          },
          {
            property: 'og:site_name',
            content: 'Screen for Type 1 Diabetes Patient Site',
          },
          {
            property: 'og:url',
            content: 'https://www.screenfortype1.com/thank-you/',
          },
          {
            property: 'og:description',
            content:
              'Thank you for signing up for updates from Screen for Type 1.',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content: 'https://www.screenfortype1.com/assets/img/SFT1-logo.png',
          },
        ],
      },
      schema: [
        {
          '@context': 'http://schema.org',
          '@type': 'MedicalWebPage',
          audience: [
            {
              '@type': 'MedicalAudience',
              audiencetype: 'Patient',
              healthCondition: [
                {
                  '@type': 'MedicalCondition',
                  name: 'Type 1 Diabetes',
                },
              ],
            },
          ],
          keywords:
            'type 1 diabetes, t1d, screen for type 1, screen for type 1 diabetes, screen it like you mean it',
          url: 'https://www.screenfortype1.com/thank-you/',
          description:
            'Thank you for signing up for updates from Screen for Type 1.',
        },
      ],
      code: 'MAT-US-2404268-v2.0',
    },
  },
  {
    path: appPaths.THANKYOU1,
    loadComponent: () =>
      import('./pages/confirmation/confirmation.component').then(
        (c) => c.ConfirmationComponent,
      ),
    // Data object for SEO and sitemap
    data: {
      seo: {
        title: 'Thank You for Signing Up | Screen for Type 1',
        metaTags: [
          {
            name: 'description',
            content:
              'Thank you for signing up for updates from Screen for Type 1.',
          },
          {
            name: 'robots',
            content: 'noindex',
          },
          {
            property: 'og:title',
            content: 'Thank You for Signing Up | Screen for Type 1',
          },
          {
            property: 'og:site_name',
            content: 'Screen for Type 1 Diabetes Patient Site',
          },
          {
            property: 'og:url',
            content: 'https://www.screenfortype1.com/thank-you/',
          },
          {
            property: 'og:description',
            content:
              'Thank you for signing up for updates from Screen for Type 1.',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content: 'https://www.screenfortype1.com/assets/img/SFT1-logo.png',
          },
        ],
      },
      schema: [
        {
          '@context': 'http://schema.org',
          '@type': 'MedicalWebPage',
          audience: [
            {
              '@type': 'MedicalAudience',
              audiencetype: 'Patient',
              healthCondition: [
                {
                  '@type': 'MedicalCondition',
                  name: 'Type 1 Diabetes',
                },
              ],
            },
          ],
          keywords:
            'type 1 diabetes, t1d, screen for type 1, screen for type 1 diabetes, screen it like you mean it',
          url: 'https://www.screenfortype1.com/thank-you/',
          description:
            'Thank you for signing up for updates from Screen for Type 1.',
        },
      ],
      code: 'MAT-US-2404268-v6.0',
      date: '04/2025',
    },
  },
  {
    path: appPaths.THANKYOU2,
    loadComponent: () =>
      import('./pages/confirmation/confirmation.component').then(
        (c) => c.ConfirmationComponent,
      ),
    // Data object for SEO and sitemap
    data: {
      seo: {
        title: 'Thank You for Signing Up | Screen for Type 1',
        metaTags: [
          {
            name: 'description',
            content:
              'Thank you for signing up for updates from Screen for Type 1.',
          },
          {
            name: 'robots',
            content: 'noindex',
          },
          {
            property: 'og:title',
            content: 'Thank You for Signing Up | Screen for Type 1',
          },
          {
            property: 'og:site_name',
            content: 'Screen for Type 1 Diabetes Patient Site',
          },
          {
            property: 'og:url',
            content: 'https://www.screenfortype1.com/thank-you/',
          },
          {
            property: 'og:description',
            content:
              'Thank you for signing up for updates from Screen for Type 1.',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content: 'https://www.screenfortype1.com/assets/img/SFT1-logo.png',
          },
        ],
      },
      schema: [
        {
          '@context': 'http://schema.org',
          '@type': 'MedicalWebPage',
          audience: [
            {
              '@type': 'MedicalAudience',
              audiencetype: 'Patient',
              healthCondition: [
                {
                  '@type': 'MedicalCondition',
                  name: 'Type 1 Diabetes',
                },
              ],
            },
          ],
          keywords:
            'type 1 diabetes, t1d, screen for type 1, screen for type 1 diabetes, screen it like you mean it',
          url: 'https://www.screenfortype1.com/thank-you/',
          description:
            'Thank you for signing up for updates from Screen for Type 1.',
        },
      ],
      code: 'MAT-US-2404268-v6.0',
      date: '04/2025',
    },
  },
  {
    path: appPaths.THANKYOU3,
    loadComponent: () =>
      import('./pages/confirmation/confirmation.component').then(
        (c) => c.ConfirmationComponent,
      ),
    // Data object for SEO and sitemap
    data: {
      seo: {
        title: 'Thank You for Signing Up | Screen for Type 1',
        metaTags: [
          {
            name: 'description',
            content:
              'Thank you for signing up for updates from Screen for Type 1.',
          },
          {
            name: 'robots',
            content: 'noindex',
          },
          {
            property: 'og:title',
            content: 'Thank You for Signing Up | Screen for Type 1',
          },
          {
            property: 'og:site_name',
            content: 'Screen for Type 1 Diabetes Patient Site',
          },
          {
            property: 'og:url',
            content: 'https://www.screenfortype1.com/thank-you/',
          },
          {
            property: 'og:description',
            content:
              'Thank you for signing up for updates from Screen for Type 1.',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content: 'https://www.screenfortype1.com/assets/img/SFT1-logo.png',
          },
        ],
      },
      schema: [
        {
          '@context': 'http://schema.org',
          '@type': 'MedicalWebPage',
          audience: [
            {
              '@type': 'MedicalAudience',
              audiencetype: 'Patient',
              healthCondition: [
                {
                  '@type': 'MedicalCondition',
                  name: 'Type 1 Diabetes',
                },
              ],
            },
          ],
          keywords:
            'type 1 diabetes, t1d, screen for type 1, screen for type 1 diabetes, screen it like you mean it',
          url: 'https://www.screenfortype1.com/thank-you/',
          description:
            'Thank you for signing up for updates from Screen for Type 1.',
        },
      ],
      code: 'MAT-US-2404268-v6.0',
      date: '04/2025',
    },
  },
  {
    path: appPaths.THANKYOU4,
    loadComponent: () =>
      import('./pages/confirmation/confirmation.component').then(
        (c) => c.ConfirmationComponent,
      ),
    // Data object for SEO and sitemap
    data: {
      seo: {
        title: 'Thank You for Signing Up | Screen for Type 1',
        metaTags: [
          {
            name: 'description',
            content:
              'Thank you for signing up for updates from Screen for Type 1.',
          },
          {
            name: 'robots',
            content: 'noindex',
          },
          {
            property: 'og:title',
            content: 'Thank You for Signing Up | Screen for Type 1',
          },
          {
            property: 'og:site_name',
            content: 'Screen for Type 1 Diabetes Patient Site',
          },
          {
            property: 'og:url',
            content: 'https://www.screenfortype1.com/thank-you/',
          },
          {
            property: 'og:description',
            content:
              'Thank you for signing up for updates from Screen for Type 1.',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content: 'https://www.screenfortype1.com/assets/img/SFT1-logo.png',
          },
        ],
      },
      schema: [
        {
          '@context': 'http://schema.org',
          '@type': 'MedicalWebPage',
          audience: [
            {
              '@type': 'MedicalAudience',
              audiencetype: 'Patient',
              healthCondition: [
                {
                  '@type': 'MedicalCondition',
                  name: 'Type 1 Diabetes',
                },
              ],
            },
          ],
          keywords:
            'type 1 diabetes, t1d, screen for type 1, screen for type 1 diabetes, screen it like you mean it',
          url: 'https://www.screenfortype1.com/thank-you/',
          description:
            'Thank you for signing up for updates from Screen for Type 1.',
        },
      ],
      code: 'MAT-US-2404268-v6.0',
      date: '04/2025',
    },
  },
  {
    path: appPaths.SPANISH,
    loadComponent: () =>
      import('./pages/spanish/spanish.component').then(
        (c) => c.SpanishComponent,
      ),
    // Data object for SEO and sitemap
    data: {
      seo: {
        title:
          'Hágase La Prueba de Detección como Si Fuera en Serio | Formulario de Selección Tipo 1',
        metaTags: [
          {
            name: 'description',
            content:
              'Descubra por qué es importante detectar la diabetes de tipo 1 antes de que se produzcan complicaciones graves y sea necesario administrar insulina.',
          },
          {
            property: 'og:title',
            content:
              'Hágase La Prueba de Detección como Si Fuera en Serio | Formulario de Selección Tipo 1',
          },
          {
            property: 'og:site_name',
            content: 'Screen for Type 1 Diabetes Patient Site',
          },
          {
            property: 'og:url',
            content: 'https://www.screenfortype1.com/es/',
          },
          {
            property: 'og:description',
            content:
              'Descubra por qué es importante detectar la diabetes de tipo 1 antes de que se produzcan complicaciones graves y sea necesario administrar insulina.',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content:
              'https://www.screenfortype1.com/assets/img/SFT1-spanish_logo.png',
          },
        ],
        locale: 'es-US',
      },
      hreflang: [
        {
          rel: 'alternate',
          href: 'https://www.screenfortype1.com/',
          hreflang: 'x-default',
        },
        {
          rel: 'alternate',
          href: 'https://www.screenfortype1.com/',
          hreflang: 'en-us',
        },
        {
          rel: 'alternate',
          href: 'https://www.screenfortype1.com/es/',
          hreflang: 'es-us',
        },
      ],
      schema: [
        {
          '@context': 'http://schema.org',
          '@type': 'MedicalWebPage',
          audience: [
            {
              '@type': 'MedicalAudience',
              audiencetype: 'Patient',
              healthCondition: [
                {
                  '@type': 'MedicalCondition',
                  name: 'Type 1 Diabetes',
                },
              ],
            },
          ],
          keywords:
            'type 1 diabetes, t1d, screen for type 1, screen for type 1 diabetes, screen it like you mean it',
          url: 'https://www.screenfortype1.com/es/',
          description:
            'Descubra por qué es importante detectar la diabetes de tipo 1 antes de que se produzcan complicaciones graves y sea necesario administrar insulina.',
        },
      ],
      code: 'MAT-US-2404345-v4.0',
      date: '09/2026',
      year: '2026',
    },
  },
  {
    path: appPaths.SITEMAP,
    loadComponent: () =>
      import('./pages/sitemap/sitemap.component').then(
        (c) => c.SitemapComponent,
      ),
    // Data object for SEO and sitemap
    data: {
      seo: {
        title: 'Site Map | Screen for Type 1',
        metaTags: [
          {
            name: 'description',
            content:
              'Browse the Screen for Type 1 site map to help you navigate the site.',
          },
          {
            property: 'og:title',
            content: 'Site Map | Screen for Type 1',
          },
          {
            property: 'og:site_name',
            content: 'Screen for Type 1 Diabetes Patient Site',
          },
          {
            property: 'og:url',
            content: 'https://www.screenfortype1.com/site-map/',
          },
          {
            property: 'og:description',
            content:
              'Browse the Screen for Type 1 site map to help you navigate the site.',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content: 'https://www.screenfortype1.com/assets/img/SFT1-logo.png',
          },
        ],
      },
      schema: [
        {
          '@context': 'http://schema.org',
          '@type': 'MedicalWebPage',
          audience: [
            {
              '@type': 'MedicalAudience',
              audiencetype: 'Patient',
              healthCondition: [
                {
                  '@type': 'MedicalCondition',
                  name: 'Type 1 Diabetes',
                },
              ],
            },
          ],
          keywords:
            'type 1 diabetes, t1d, screen for type 1, screen for type 1 diabetes, screen it like you mean it',
          url: 'https://www.screenfortype1.com/site-map/',
          description:
            'Browse the Screen for Type 1 site map to help you navigate the site.',
        },
      ],
      code: 'MAT-US-2306137-v12.0',
      date: '08/2026',
      year: '2026',
    },
  },
  {
    path: 'make-a-plan',
    redirectTo: appPaths.BENEFITSOFKNOWING,
  },
  {
    path: 'useful-tools',
    redirectTo: appPaths.USEFULTOOLS,
  },
  {
    path: 'resources',
    redirectTo: appPaths.USEFULTOOLS,
  },
  {
    path: appPaths.NOTFOUND,
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then(
        (notFound) => notFound.NotFoundComponent,
      ),
    data: {
      seo: {
        title: 'Page Not Found | Screen For Type 1',
        metaTags: [
          {
            name: 'description',
            content: 'Not Found',
          },
        ],
      },
      code: defaultCode,
    },
  },
  {
    path: appPaths.EARLYDETECTION,
    loadComponent: () =>
      import('./pages/early-detection/early-detection.component').then(
        (c) => c.EarlyDetectionComponent,
      ),
    // Data object for SEO and sitemap
    data: {
      seo: {
        title:
          'Early Detection of Type 1 Diabetes (T1D) | Screen for Type 1 for HCPs',
        metaTags: [
          {
            name: 'description',
            content:
              'See why early detection of Type 1 Diabetes (T1D) matters and can help reduce the risk of diabetic ketoacidosis (DKA). Learn more about beta cell function and the role of C-Peptide in T1D, metabolic memory, and the long-term impact of T1D.',
          },
          {
            property: 'og:title',
            content:
              'Early Detection of Type 1 Diabetes (T1D) | Screen for Type 1 for HCPs',
          },
          {
            property: 'og:site_name',
            content: 'Screen for Type 1 Diabetes HCP Site',
          },
          {
            property: 'og:url',
            content:
              'https://www.screenfortype1.com/hcp/early-detection-of-t1d/',
          },
          {
            property: 'og:description',
            content:
              'See why early detection of Type 1 Diabetes (T1D) matters and can help reduce the risk of diabetic ketoacidosis (DKA). Learn more about beta cell function and the role of C-Peptide in T1D, metabolic memory, and the long-term impact of T1D.',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content: 'https://www.screenfortype1.com/assets/img/SFT1-logo.png',
          },
        ],
      },
      schema: [
        {
          '@context': 'http://schema.org',
          '@type': 'MedicalWebPage',
          audience: [
            {
              '@type': 'MedicalAudience',
              audiencetype: 'Healthcare Providers',
              healthCondition: [
                {
                  '@type': 'MedicalCondition',
                  name: 'Type 1 Diabetes',
                },
              ],
            },
          ],
          keywords:
            'type 1 diabetes, t1d, screen for type 1, screen for type 1 diabetes, screen it like you mean it',
          url: 'https://www.screenfortype1.com/hcp/early-detection-of-t1d/',
          description:
            'See why early detection of Type 1 Diabetes (T1D) matters and can help reduce the risk of diabetic ketoacidosis (DKA). Learn more about beta cell function and the role of C-Peptide in T1D, metabolic memory, and the long-term impact of T1D.',
        },
      ],
      sitemap: {
        text: 'Early Detection Matters', //url text
        fragments: [], //fragments (if apply)
      },

      code: 'MAT-US-2404346-v6.0',
      date: '08/2026',
      year: '2026',
    },
  },
  {
    path: appPaths.T1DFAMILYHISTORY,
    loadComponent: () =>
      import('./pages/family-history/family-history.component').then(
        (c) => c.FamilyHistoryComponent,
      ),
    // Data object for SEO and sitemap
    data: {
      seo: {
        title:
          'Type 1 Diabetes (T1D) & Family History | Screen for Type 1 for HCPs',
        metaTags: [
          {
            name: 'description',
            content:
              'Help patients understand how family history of Type 1 Diabetes (T1D) can increase risk of T1D and how to discuss screening with your patients.',
          },
          {
            property: 'og:title',
            content:
              'Type 1 Diabetes (T1D) & Family History | Screen for Type 1 for HCPs',
          },
          {
            property: 'og:site_name',
            content: 'Screen for Type 1 Diabetes HCP Site',
          },
          {
            property: 'og:url',
            content: 'https://www.screenfortype1.com/hcp/t1d-family-history/',
          },
          {
            property: 'og:description',
            content:
              'Help patients understand how family history of Type 1 Diabetes (T1D) can increase risk of T1D and how to discuss screening with your patients.',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content: 'https://www.screenfortype1.com/assets/img/SFT1-logo.png',
          },
        ],
      },
      schema: [
        {
          '@context': 'http://schema.org',
          '@type': 'MedicalWebPage',
          audience: [
            {
              '@type': 'MedicalAudience',
              audiencetype: 'Healthcare Providers',
              healthCondition: [
                {
                  '@type': 'MedicalCondition',
                  name: 'Type 1 Diabetes',
                },
              ],
            },
          ],
          keywords:
            'type 1 diabetes, t1d, screen for type 1, screen for type 1 diabetes, screen it like you mean it',
          url: 'https://www.screenfortype1.com/hcp/t1d-family-history/',
          description:
            'Help patients understand how family history of Type 1 Diabetes (T1D) can increase risk of T1D and how to discuss screening with your patients.',
        },
      ],
      sitemap: {
        text: 'T1D and Family History', //url text
        fragments: [], //fragments (if apply)
      },

      code: 'MAT-US-2608692-v1.0',
      date: '08/2026',
      year: '2026',
    },
  },
  {
    path: appPaths.RESOURCE,
    loadComponent: () =>
      import('./pages/resource/resource').then((c) => c.Resource),
    // Data object for SEO and sitemap
    data: {
      seo: {
        title: 'T1D Screening Resources | Screen for Type 1 Diabetes for HCPs',
        metaTags: [
          {
            name: 'description',
            content:
              'Discover Type 1 Diabetes (T1D) screening resources for HCPs including information on autoantibody blood screening and how to explain T1D screening to your patients.',
          },
          {
            property: 'og:title',
            content:
              'T1D Screening Resources | Screen for Type 1 Diabetes for HCPs',
          },
          {
            property: 'og:site_name',
            content: 'Screen for Type 1 Diabetes HCP Site',
          },
          {
            property: 'og:url',
            content:
              'https://www.screenfortype1.com/hcp/t1d-screening-resources/',
          },
          {
            property: 'og:description',
            content:
              'Discover Type 1 Diabetes (T1D) screening resources for HCPs including information on autoantibody blood screening and how to explain T1D screening to your patients.',
          },
          {
            property: 'og:type',
            content: 'website',
          },
          {
            property: 'og:image',
            content: 'https://www.screenfortype1.com/assets/img/SFT1-logo.png',
          },
        ],
      },
      schema: [
        {
          '@context': 'http://schema.org',
          '@type': 'MedicalWebPage',
          audience: [
            {
              '@type': 'MedicalAudience',
              audiencetype: 'Healthcare Providers',
              healthCondition: [
                {
                  '@type': 'MedicalCondition',
                  name: 'Type 1 Diabetes',
                },
              ],
            },
          ],
          keywords:
            'type 1 diabetes, t1d, screen for type 1, screen for type 1 diabetes, screen it like you mean it',
          url: 'https://www.screenfortype1.com/hcp/t1d-screening-resources/',
          description:
            'Discover Type 1 Diabetes (T1D) screening resources for HCPs including information on autoantibody blood screening and how to explain T1D screening to your patients.',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          description:
            'When Chrissy Teigen’s son was diagnosed with type 1 diabetes (T1D), Dr. Lauren Crosby – a nationally recognized parenting expert and pediatrician – became her go-to person for all things T1D education and management. With the goal of improving T1D awareness and dispelling the misinformation around the disease, Dr. Crosby is sharing four things she wants everyone to know about T1D, including why T1D screening can be a valuable tool for families. Talk to your doctor about making a T1D screening plan today.',
          name: '4 Things a Doctor Wants You to Know About T1D',
          thumbnailUrl: 'https://i.ytimg.com/vi/ea43d6xfS_c/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=ea43d6xfS_c',
          uploadDate: '2025-11-13',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          name: "Amanda's T1D Screening Story",
          thumbnailUrl: 'https://i.ytimg.com/vi/mVYWGmFLcoY/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=mVYWGmFLcoY',
          uploadDate: '2025-02-28',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          name: "The Hoffman Family's T1D Diagnosis Journey",
          thumbnailUrl: 'https://i.ytimg.com/vi/JIoHCnBRX0U/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=JIoHCnBRX0U',
          uploadDate: '2025-08-21',
        },
        {
          '@context': 'http://schema.org',
          '@type': 'VideoObject',
          name: "The Zortman Family's T1D Diagnosis Journey",
          thumbnailUrl: 'https://i.ytimg.com/vi/6acIYCHhwHY/sddefault.jpg',
          embedUrl: 'https://www.youtube.com/watch?v=6acIYCHhwHY',
          uploadDate: '2026-05-27',
        },
      ],
      sitemap: {
        text: 'HCP Resources', //url text
        fragments: [], //fragments (if apply)
      },

      code: 'MAT-US-2608693-v1.0',
      date: '08/2026',
      year: '2026',
    },
  },
  {
    path: appPaths.REQUESTSCREENING,
    redirectTo: appPaths.HOWTOSCREEN,
  },

  // PDF Redirects - Action Plans
  {
    path: 'assets/pdf/Make%20a%20Plan%20Downloadable_Print.pdf',
    redirectTo: 'assets/pdf/type-1-diabetes-action-plan.pdf',
  },
  {
    path: 'assets/pdf/Make a Plan Downloadable_Print.pdf',
    redirectTo: '/type-1-diabetes-action-plan.pdf',
  },
  {
    path: 'assets/pdf/Make%20a%20Plan%20Downloadable_Mobile.pdf',
    redirectTo: '/type-1-diabetes-action-plan-mobile.pdf',
  },
  {
    path: 'assets/pdf/Make a Plan Downloadable_Mobile.pdf',
    redirectTo: '/type-1-diabetes-action-plan-mobile.pdf',
  },

  // PDF Redirects - Doctor Discussion Guides (English)
  {
    path: 'assets/pdf/type-1-diabetes-screening-doctor-discussion-guide.pdf',
    redirectTo: '/type-1-diabetes-screening-doctor-discussion-guide.pdf',
  },
  {
    path: 'assets/pdf/type-1-diabetes-screening-doctor-discussion-guide-mobile.pdf',
    redirectTo: '/type-1-diabetes-screening-doctor-discussion-guide-mobile.pdf',
  },
  {
    path: 'assets/pdf/type-1-diabetes-screening-doctor-discussion-guide-mobile.pdf',
    redirectTo: '/type-1-diabetes-screening-doctor-discussion-guide-mobile.pdf',
  },

  // PDF Redirects - Screening Guides (English)
  {
    path: 'assets/pdf/Screening_Guide_Eng_Print.pdf',
    redirectTo: '/type-1-diabetes-screening-guide.pdf',
  },
  {
    path: 'assets/pdf/Screening_Guide_Eng_Mobile.pdf',
    redirectTo: '/type-1-diabetes-screening-guide-mobile.pdf',
  },

  // PDF Redirects - Quick Start Guides (English)
  {
    path: 'assets/pdf/type-1-diabetes-screening-quick-start-guide.pdf',
    redirectTo: '/type-1-diabetes-screening-quick-start-guide.pdf',
  },
  {
    path: 'assets/pdf/type-1-diabetes-screening-quick-start-guide-mobile.pdf',
    redirectTo: '/type-1-diabetes-screening-quick-start-guide-mobile.pdf',
  },
  {
    path: 'assets/pdf/Patient AAb Screening 1-pager_Mobile.pdf',
    redirectTo: '/type-1-diabetes-screening-quick-start-guide-mobile.pdf',
  },

  // PDF Redirects - Autoantibody Guides (English)
  {
    path: 'assets/pdf/Autoantibody%20Guide_Print.pdf',
    redirectTo: '/type-1-diabetes-autoantibody-guide.pdf',
  },
  {
    path: 'assets/pdf/Autoantibody Guide_Print.pdf',
    redirectTo: '/type-1-diabetes-autoantibody-guide.pdf',
  },
  {
    path: 'assets/pdf/Autoantibody%20Guide_Mobile.pdf',
    redirectTo: '/type-1-diabetes-autoantibody-guide-mobile.pdf',
  },
  {
    path: 'assets/pdf/Autoantibody Guide_Mobile.pdf',
    redirectTo: '/type-1-diabetes-autoantibody-guide-mobile.pdf',
  },
  {
    path: 'assets/pdf/C-Peptide%20Testing.pdf',
    redirectTo: '/type-1-diabetes-autoantibody-guide.pdf',
  },
  {
    path: 'assets/pdf/C-Peptide Testing.pdf',
    redirectTo: '/type-1-diabetes-autoantibody-guide.pdf',
  },

  // PDF Redirects - Doctor Discussion Guides (Spanish)
  {
    path: 'assets/pdf/Doctor%20Discussion%20Guide_Print_Spanish.pdf',
    redirectTo: '/type-1-diabetes-doctor-discussion-guide-espanol.pdf',
  },
  {
    path: 'assets/pdf/Doctor Discussion Guide_Print_Spanish.pdf',
    redirectTo: '/type-1-diabetes-doctor-discussion-guide-espanol.pdf',
  },
  {
    path: 'assets/pdf/Doctor%20Discussion%20Guide_Mobile_Spanish.pdf',
    redirectTo: '/type-1-diabetes-doctor-discussion-guide-espanol-movil.pdf',
  },
  {
    path: 'assets/pdf/Doctor Discussion Guide_Mobile_Spanish.pdf',
    redirectTo: '/type-1-diabetes-doctor-discussion-guide-espanol-movil.pdf',
  },

  // PDF Redirects - Screening Guides (Spanish)
  {
    path: 'assets/pdf/Screening%20Guide_Print_Spanish.pdf',
    redirectTo: '/type-1-diabetes-screening-guide-espanol.pdf',
  },
  {
    path: 'assets/pdf/Screening Guide_Print_Spanish.pdf',
    redirectTo: '/type-1-diabetes-screening-guide-espanol.pdf',
  },
  {
    path: 'assets/pdf/Screening%20Guide_Mobile_Spanish.pdf',
    redirectTo: '/type-1-diabetes-screening-guide-espanol-movil.pdf',
  },
  {
    path: 'assets/pdf/Screening Guide_Mobile_Spanish.pdf',
    redirectTo: '/type-1-diabetes-screening-guide-espanol-movil.pdf',
  },

  // PDF Redirects - Quick Start Guides (Spanish)
  {
    path: 'assets/pdf/Screening%20Quick%20Start_Print_Spanish.pdf',
    redirectTo: '/type-1-diabetes-screening-quick-start-guide-espanol.pdf',
  },
  {
    path: 'assets/pdf/Screening Quick Start_Print_Spanish.pdf',
    redirectTo: '/type-1-diabetes-screening-quick-start-guide-espanol.pdf',
  },
  {
    path: 'assets/pdf/Screening%20Quick%20Start_Mobile_Spanish.pdf',
    redirectTo:
      '/type-1-diabetes-screening-quick-start-guide-espanol-movil.pdf',
  },
  {
    path: 'assets/pdf/Screening Quick Start_Mobile_Spanish.pdf',
    redirectTo:
      '/type-1-diabetes-screening-quick-start-guide-espanol-movil.pdf',
  },

  // PDF Redirects - Autoantibody Guides (Spanish)
  {
    path: 'assets/pdf/Autoantibody%20Guide_Print_Spanish.pdf',
    redirectTo: '/type-1-diabetes-autoantibody-guide-espanol.pdf',
  },
  {
    path: 'assets/pdf/Autoantibody Guide_Print_Spanish.pdf',
    redirectTo: '/type-1-diabetes-autoantibody-guide-espanol.pdf',
  },
  {
    path: 'assets/pdf/Autoantibody%20Guide_Mobile_Spanish.pdf',
    redirectTo: '/type-1-diabetes-autoantibody-guide-espanol-movil.pdf',
  },
  {
    path: 'assets/pdf/Autoantibody Guide_Mobile_Spanish.pdf',
    redirectTo: '/type-1-diabetes-autoantibody-guide-espanol-movil.pdf',
  },

  // PDF Redirects - Family Factor Survey
  {
    path: 'assets/pdf/the-family-factor-t1d-survey-information.pdf',
    redirectTo: '/the-family-factor-t1d-survey-information.pdf',
  },

  {
    path: appPaths.UNKNOWN,
    redirectTo: appPaths.NOTFOUND,
  },
];
